/* Naylumi · Ficha 2c — micro-animaciones y agregar al carrito.
   200 a 500 ms, ease-out, solo opacidad y transform. Respetan prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.__nay2cReady) return;
  window.__nay2cReady = true;

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEC_CAJON = 'cart-drawer-section';

  function listo(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function revelar(el) {
    if (!el) return;
    if (quieto || !('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { el.classList.add('is-in'); io.disconnect(); }
    }, { threshold: 0.3 });
    io.observe(el);
  }

  function bandaPorTitulo(re) {
    var out = null;
    document.querySelectorAll('.nay2c__band').forEach(function (b) {
      var h = b.querySelector('.nay2c__h2');
      if (h && re.test(h.textContent)) out = b;
    });
    return out;
  }

  /* Cross-fade de la galería al cambiar de color */
  function crossFade() {
    var root = document.querySelector('[data-n2t]');
    if (!root) return;
    root.addEventListener('change', function (e) {
      if (!e.target.matches('input[data-n2t-opt]')) return;
      var gal = root.querySelector('[data-n2t-gal]');
      if (!gal || quieto) return;
      gal.classList.add('is-fading');
      setTimeout(function () { gal.classList.remove('is-fading'); }, 250);
    });
  }

  /* Burbuja del carrito en el menú.
     El tema deja la clase 'hidden' puesta cuando el carrito arrancó vacío,
     así que además de escribir el número hay que quitarla. */
  function pintarContador(n) {
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      if (n > 0) el.classList.remove('hidden');
      else el.classList.add('hidden');
    });
  }

  function sincronizarContador() {
    try {
      if (window.naylumiSyncCartCounters) window.naylumiSyncCartCounters();
      else if (window.naylumiScheduleCartSync) window.naylumiScheduleCartSync();
    } catch (e) {}

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c && c.item_count ? c.item_count : 0;
        pintarContador(n);
        setTimeout(function () { pintarContador(n); }, 700);
      })
      .catch(function () {});
  }

  /* Pinta el cajón del carrito con el HTML que devuelve Shopify y lo abre.
     Si el tema no tiene cajón, cae a la página /cart. */
  function abrirCarrito(html) {
    var cont = document.getElementById('shopify-section-' + SEC_CAJON);
    if (html && cont) {
      try { cont.innerHTML = html; } catch (e) {}
    }

    var caj = document.getElementById('cart-drawer');
    if (caj && typeof caj.open === 'function') {
      try {
        caj.open();
        sincronizarContador();
        return true;
      } catch (e) {}
    }

    window.location.href = '/cart';
    return false;
  }

  /* Agregado al carrito */
  function agregar() {
    var root = document.querySelector('[data-n2t]');
    if (!root) return;
    var form = root.querySelector('form');
    var btn = root.querySelector('[data-n2t-add]');
    if (!form || !btn) return;

    if (!btn.querySelector('.n2t__check')) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('class', 'n2t__check');
      svg.innerHTML = '<path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>';
      btn.appendChild(svg);
    }

    form.addEventListener('submit', function (ev) {
      var id = root.querySelector('[data-n2t-id]');
      if (!id || !id.value) return;
      ev.preventDefault();
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id.value), quantity: 1 }],
          sections: SEC_CAJON,
          sections_url: window.location.pathname
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      }).then(function (d) {
        btn.classList.add('is-added');

        var burbuja = document.querySelector('.cart-bubble');
        if (burbuja && !quieto) {
          burbuja.classList.add('n2t-bump');
          setTimeout(function () { burbuja.classList.remove('n2t-bump'); }, 400);
        }

        setTimeout(function () {
          var abrio = abrirCarrito(d && d.sections ? d.sections[SEC_CAJON] : null);
          if (abrio) {
            btn.disabled = false;
            btn.classList.remove('is-added');
          }
        }, quieto ? 0 : 520);
      }).catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-added');
        form.submit();
      });
    });
  }

  /* Fila de garantías: entrada escalonada + WhatsApp enlazado */
  function garantias() {
    var fila = document.querySelector('.n2t__gar');
    if (!fila || fila.dataset.n2tListo) return;
    fila.dataset.n2tListo = '1';

    var items = fila.querySelectorAll('.n2t__g');

    items.forEach(function (g) {
      var svg = g.querySelector('svg');
      if (svg && !svg.parentElement.classList.contains('n2t__ico')) {
        var caja = document.createElement('span');
        caja.className = 'n2t__ico';
        svg.parentNode.insertBefore(caja, svg);
        caja.appendChild(svg);
      }
    });

    var ultimo = items[items.length - 1];
    if (ultimo && ultimo.tagName !== 'A') {
      var url = '';
      var propio = document.querySelector('.n2t__wa');
      if (propio && propio.href) url = propio.href;
      if (!url) {
        var otro = document.querySelector('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
        if (otro) url = otro.href;
      }
      if (url) {
        var a = document.createElement('a');
        a.className = ultimo.className + ' n2t__g--wa';
        a.href = url;
        a.target = '_blank';
        a.rel = 'noopener';
        a.setAttribute('aria-label', 'Escríbenos por WhatsApp');
        while (ultimo.firstChild) a.appendChild(ultimo.firstChild);
        ultimo.parentNode.replaceChild(a, ultimo);
      }
    }

    revelar(fila);
  }

  /* Escena: el paquete que llega. Caja isométrica de línea, cae y se ata el moño. */
  var ESCENA =
    '<svg class="n2t__esc" viewBox="0 0 200 168" aria-hidden="true"><ellipse class="n2t__sombra" cx="100" cy="138" rx="43" ry="6.5" fill="#2A2229"/><g class="n2t__cubo" fill="none" stroke-linecap="round" stroke-linejoin="round"><path class="c-l c1" d="M100 30 L158 56 L100 82 L42 56 Z" stroke="#2A2229" stroke-width="1.8"/><path class="c-l c2" d="M42 56 L42 104 L100 130 L100 82" stroke="#2A2229" stroke-width="1.8"/><path class="c-l c3" d="M158 56 L158 104 L100 130 L100 82" stroke="#2A2229" stroke-width="1.8"/><path class="r-l r1" d="M71 43 L129 69" stroke="#B5677A" stroke-width="2.4"/><path class="r-l r2" d="M129 43 L71 69" stroke="#B5677A" stroke-width="2.4"/><path class="r-l r3" d="M71 69 L71 117" stroke="#B5677A" stroke-width="2.4"/><path class="r-l r4" d="M129 69 L129 117" stroke="#B5677A" stroke-width="2.4"/><g class="n2t__mono" stroke="#B5677A" stroke-width="2.2"><path d="M100 56 C86 43 71 47 78 56 C71 65 86 69 100 56 Z"/><path d="M100 56 C114 43 129 47 122 56 C129 65 114 69 100 56 Z"/><circle cx="100" cy="56" r="3.4" fill="#B5677A" stroke="none"/></g></g><g fill="#B5677A" stroke="none"><path class="n2t__chispa ch1" d="M30 52 L32 58 L38 60 L32 62 L30 68 L28 62 L22 60 L28 58 Z"/><path class="n2t__chispa ch2" d="M172 58 L173.6 62.8 L178.4 64.4 L173.6 66 L172 70.8 L170.4 66 L165.6 64.4 L170.4 62.8 Z"/><path class="n2t__chispa ch3" d="M156 112 L157.4 116.2 L161.6 117.6 L157.4 119 L156 123.2 L154.6 119 L150.4 117.6 L154.6 116.2 Z"/></g></svg>' +
    '<p class="n2t__recibe-t">Lo recibes, lo revisas por fuera y ahí pagas</p>';

  /* La escena se repite cada 5 s mientras está a la vista */
  function ciclar(esc) {
    if (!esc) return;
    if (quieto) { esc.classList.add('is-in'); return; }

    var enPantalla = false;

    function jugar() {
      if (esc.getAnimations && esc.getAnimations({ subtree: true }).length) {
        esc.getAnimations({ subtree: true }).forEach(function (a) { a.cancel(); a.play(); });
        return;
      }
      esc.classList.remove('is-in');
      esc.getBoundingClientRect();
      esc.classList.add('is-in');
    }

    if (!('IntersectionObserver' in window)) { jugar(); enPantalla = true; }
    else {
      var io = new IntersectionObserver(function (en) {
        var dentro = en[0].isIntersecting;
        if (dentro && !enPantalla) jugar();
        enPantalla = dentro;
      }, { threshold: 0.35 });
      io.observe(esc);
    }

    setInterval(function () {
      if (enPantalla && !document.hidden) jugar();
    }, 5000);
  }

  function recibe() {
    var cont = document.querySelector('.n2t__recibe');
    if (!cont) {
      var destino = bandaPorTitulo(/no pagas nada/i);
      if (!destino) return;
      cont = document.createElement('div');
      cont.className = 'n2t__recibe';
      cont.innerHTML = ESCENA;
      destino.appendChild(cont);
    }
    if (cont.dataset.n2tCiclo) return;
    cont.dataset.n2tCiclo = '1';
    revelar(cont);
    ciclar(cont.querySelector('.n2t__esc'));
  }

  /* Silueta de tallas */
  function silueta() {
    var destino = bandaPorTitulo(/tu talla/i);
    if (!destino || destino.querySelector('.n2t__sil')) return;
    var tabla = destino.querySelector('.nay2c__table');
    if (!tabla || /largo del pie/i.test(tabla.textContent)) return;

    var cont = document.createElement('div');
    cont.className = 'n2t__sil-wrap';
    cont.innerHTML =
      '<svg class="n2t__sil" viewBox="0 0 120 200" aria-hidden="true">' +
      '<path class="s-l sA" d="M60 18c7 0 12 5 12 12s-5 12-12 12-12-5-12-12 5-12 12-12z" fill="none" stroke="#2A2229" stroke-width="1.6"/>' +
      '<path class="s-l sB" d="M60 44c14 0 22 8 24 22l3 22-9 3-2 30 4 52h-40l4-52-2-30-9-3 3-22c2-14 10-22 24-22z" fill="none" stroke="#2A2229" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<path class="s-g g1" d="M20 72h80" stroke="#B5677A" stroke-width="1.2" stroke-dasharray="4 4"/>' +
      '<path class="s-g g2" d="M20 102h80" stroke="#B5677A" stroke-width="1.2" stroke-dasharray="4 4"/>' +
      '<path class="s-g g3" d="M20 126h80" stroke="#B5677A" stroke-width="1.2" stroke-dasharray="4 4"/>' +
      '</svg>' +
      '<ul class="n2t__sil-n"><li class="n1">Busto</li><li class="n2">Cintura</li><li class="n3">Cadera</li></ul>';
    destino.insertBefore(cont, tabla);
    revelar(cont);
  }

  /* Acordeón con despliegue suave */
  function acordeon() {
    document.querySelectorAll('.nay2c__faq').forEach(function (d) {
      var cuerpo = d.querySelector('.nay2c__faq-r');
      if (!cuerpo || cuerpo.parentElement.classList.contains('n2t__faq-box')) return;
      var caja = document.createElement('div');
      caja.className = 'n2t__faq-box';
      cuerpo.parentNode.insertBefore(caja, cuerpo);
      caja.appendChild(cuerpo);
    });
  }

  listo(function () {
    crossFade();
    agregar();
    garantias();
    recibe();
    silueta();
    acordeon();
  });
})();
